import { fetchGet } from '@/axios/excel.js'
/**
 * 导出订单详情
 * @param {*} params 
 */
export const exportOrderDetailExecl = params => { return fetchGet('/admin/excel/order/detail',params) }

export const exportOrderTotal = params => { return fetchGet('/admin/excel/order/total',params) }


// WEBPACK FOOTER //
// ./src/axios/excel-api.js